import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.427336"
      y="0.427336"
      width="18.1453"
      height="18.1453"
      rx="5.57266"
      fill="white"
    />
    {/* <rect
      x="0.427336"
      y="0.427336"
      width="18.1453"
      height="18.1453"
      rx="5.57266"
      stroke="#DEE5E6"
      strokeWidth="0.854671"
    /> */}
    <path
      d="M11.5585 8.21651L8.77975 5.43776C8.66632 5.32501 8.51288 5.26172 8.35295 5.26172C8.19301 5.26172 8.03957 5.32501 7.92614 5.43776C7.8694 5.49404 7.82436 5.561 7.79363 5.63477C7.76289 5.70854 7.74707 5.78767 7.74707 5.86759C7.74707 5.94751 7.76289 6.02664 7.79363 6.10041C7.82436 6.17418 7.8694 6.24114 7.92614 6.29742L10.7109 9.07012C10.7677 9.12639 10.8127 9.19335 10.8435 9.26712C10.8742 9.3409 10.89 9.42003 10.89 9.49994C10.89 9.57986 10.8742 9.65899 10.8435 9.73276C10.8127 9.80654 10.7677 9.87349 10.7109 9.92977L7.92614 12.7025C7.81215 12.8157 7.74778 12.9695 7.74722 13.1302C7.74665 13.2908 7.80992 13.4451 7.92312 13.5591C8.03631 13.6731 8.19016 13.7375 8.35081 13.738C8.51145 13.7386 8.66575 13.6753 8.77975 13.5621L11.5585 10.7834C11.8986 10.4428 12.0896 9.98123 12.0896 9.49994C12.0896 9.01866 11.8986 8.55705 11.5585 8.21651Z"
      fill="#151718"
    />
  </svg>
);

const MenuOpeningIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default MenuOpeningIcon;
